import { Card } from 'antd'
import React from 'react'

export default function CustomCard({children}) {
  return (
    <Card>{children}</Card>
  )
}
